function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.46 283.46"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Transformer"
}, /*#__PURE__*/React.createElement("path", {
  d: "M120.472 240.94l12.16-42.52h-33.42l56.7-70.86-12.16 42.52h33.42z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255.117 255.117V85.04H28.347l.006 170.077H-.001v28.348h283.466v-28.348h-28.348zm-28.344.001H56.692V113.387h170.08v141.731zM70.866 42.52h49.606v28.346H70.866zM70.866 0h49.606v28.346H70.866zM162.992 42.52h49.606v28.346h-49.606zM162.992 0h49.606v28.346h-49.606z"
}))));